
  export default {
    props: {
      phrases: {
        type: Array,
        default: () => [
          "Tuning the strings...",
          "Checking fretboard alignment...",
          "Polishing the guitar body...",
          "Adjusting the truss rod...",
          "Stretching new strings...",
          "Testing amplifier connection...",
          "Setting intonation...",
          "Lubricating the nut and bridge...",
        ],
      },
    },
    data() {
      return {
        randomPhrase: "",
      };
    },
    methods: {
      updateRandomPhrase() {
        this.randomPhrase = this.phrases[Math.floor(Math.random() * this.phrases.length)];
      },
    },
    watch: {
      // Automatically update phrases every 2 seconds while component is active
      randomPhrase() {
        if (this._isMounted) {
          setTimeout(this.updateRandomPhrase, 2000);
        }
      },
    },
    mounted() {
      this._isMounted = true;
      this.updateRandomPhrase();
    },
    beforeDestroy() {
      this._isMounted = false;
    },
  };
  